module.exports = __webpack_public_path__ + "img/especialista55.17fa5d10.png";